export default __webpack_public_path__ + "static/malaysia-railway-poles-1-e809f69e5d0f60f4021ff861c30ea0a9.jpg";